import { CustomOrder } from '@components/account/pages/orders/helpers/transformOrder'

import { Order } from '@components/account/types'
import styles from './styles.module.scss'
import OrderSummaryCosts from './OrderSummaryCosts'

function AddressBlock({
  address,
  email,
  title
}: {
  address: Partial<CustomOrder>['shippingAddress']
  email: string
  title: string
}) {
  if (!address) {
    return null
  }
  return (
    <address className={styles.addressBlock}>
      <p>
        <strong>{title}</strong>
      </p>
      <p>{address.name}</p>
      <p>{address.address1}</p>
      <p>{address.address2}</p>
      <p>{address.city}</p>
      <p>{address.country}</p>
      <p>{address.province}</p>
      <p>{address.zip}</p>
      <p>{email}</p>
      <p>{address.phoneNumber}</p>
    </address>
  )
}

export default function OrderPageContentSummary({ order }: { order: Order }) {
  return (
    <div className={styles.OrderPageContent__summary}>
      <OrderSummaryCosts order={order} />
      <div className={styles.separator}></div>
      <AddressBlock
        address={order.shippingAddress}
        title="Delivery Address"
        email={order.email}
      />
      <AddressBlock
        address={order.billingAddress}
        title="Billing Address"
        email={order.email}
      />
    </div>
  )
}
